const dividerStyles = {
    m: 1.0625,
    height: 1.0625,
    bgcolor: "black"
};

export const DividerStyles = dividerStyles;

const iconStyles = {
    fontSize: {
        xs: "3.85rem",
        sm: "3.9rem",
        md: "3.95rem",
        lg: "4rem",
    },
};

export const IconStyles = iconStyles;